import React, { CSSProperties, Fragment, useContext, useEffect, useState } from 'react'
import { KTCard, KTCardBody, KTIcon, } from '../../../_metronic/helpers'
import { useNavigate } from 'react-router'

import toast from 'react-hot-toast'
import ComponentSpinner from '../../modules/apps/user-management/users-list/components/loading/Loading-spinner'
import moment from 'moment'
import { Button, Col, Container, Input, Label, Row, Table } from 'reactstrap'
import { JobService } from '../../modules/Services/Job'
import ReactSelect from 'react-select'
import { customSelectStyles, formatCurrency, selectThemeColors } from '../../modules/commonModel/Utils'
import { CustomerService } from '../../modules/Services/Customers'
import AsyncSelect from 'react-select/async'
import { FilterDetails } from '../../App'
import UILoader from '../../modules/commonModel/Ui-loader'
import { TagsService } from '../../modules/Services/Tags'
import { Icon } from '@iconify/react'

import { Dayjs } from 'dayjs';
import { DateRange } from '@mui/x-date-pickers-pro/models';
import MultiDatePickr from '../../modules/commonModel/MultiDatePickr'
import InvoiceModel from '../Invoices/InvoiceModel'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import ImportBookingModal from './ImportBookingModal'
import ConfirmModal from '../../modules/commonModel/ConfirmModal'

const bookingStyle: CSSProperties = {
  width: '120px',
  height: '35px',
  borderRadius: '6px',
  backgroundColor: '#1b84ff',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '13px'
};

const JobPage = () => {

  const tableHearder = [
    { label: 'Booking ID', asc_desc: undefined, value: 'booking_number', style: 'pointer' },
    { label: 'Booking Name', asc_desc: undefined, value: 'job_name', style: 'pointer' },
    { label: 'Client', asc_desc: undefined, value: 'customer_name', style: 'pointer' },
    { label: 'Destination', asc_desc: undefined, value: null, style: '' },
    { label: 'Job Dates', asc_desc: undefined, value: 'start_at_date', style: 'pointer' },
    { label: 'Payment', asc_desc: undefined, value: 'payment_status', style: 'pointer' },
    { label: 'Jobs', asc_desc: undefined, value: null, style: '' },
    { label: 'Charge', asc_desc: undefined, value: null, style: '' }
  ]

  const [filterValue, setFilterValue] = useContext<any>(FilterDetails)
  const [pending, setPending] = useState(false)
  const navigate = useNavigate()
  const [bookingData, setBookingData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const entity_id = localStorage.getItem('entity_id')
  const [currentCustomer, setCurrentCustomer] = useState((Object.keys(filterValue?.bookings?.customer).length > 0) ? filterValue?.bookings?.customer : { value: '', label: 'Select Client' })
  const [statusData, setStatusData] = useState([])
  const [currentStatus, setCurrentStatus] = useState((Object.keys(filterValue?.bookings?.status).length > 0) ? filterValue?.bookings?.status : { value: '', label: 'Select Status' })
  const [searchTerm, setSearchTerm] = useState(Object.keys(filterValue?.bookings?.booking_search)?.length ? filterValue?.bookings?.booking_search : '')
  const [renderElementService, setRenderElementService] = useState(1)
  const [nextPage, setNextPage] = useState(null)
  const [tagData, setTagData] = useState([{ value: '', label: 'Select Tag' }])
  const [currentTag, setCurrentTag] = useState((Object.keys(filterValue?.bookings?.tag).length > 0) ? filterValue?.bookings?.tag : { value: '', label: 'Select Tag' })
  let customerTimeoutId: ReturnType<typeof setTimeout> | null = null;
  const [tableHearderField, setTableHearderField] = useState(tableHearder)
  const [sortOrder, setSortOrder] = useState((Object.keys(filterValue?.bookings?.order_by).length > 0) ? filterValue?.bookings?.order_by : 'desc');
  const [sort, setSort] = useState((Object.keys(filterValue?.bookings?.sort_by).length > 0) ? filterValue?.bookings?.sort_by : 'booking_number');

  const [selectedDateRange, setSelectedDateRange] = React.useState<DateRange<Dayjs>>((Object.keys(filterValue?.bookings?.date).length > 0) ? filterValue?.bookings?.date : [null, null]);
  const [bookingDate, setBookingDate] = useState((Object.keys(filterValue?.bookings?.date).length > 0) ? filterValue?.bookings?.date : [null, null]);
  const [currentPayment, setCurrentPayment] = useState((Object.keys(filterValue?.bookings?.payment).length > 0) ? filterValue?.bookings?.payment : { value: '', label: 'Select Payment' })
  const [paymentData, setPaymentData] = useState([{ value: '', label: 'Select Payment' }])
  const [changeCheckbox, setChangeCheckbox] = useState([])
  const [checkedData, setCheckedData] = useState([])
  const [selectAll, setSelectAll] = useState({ all: false, checkbox: false, count: 0 })
  const [currentSelected, setCurrentSelected] = useState({ value: null, label: 'With Selected' })
  const [openInvoice, setOpenInvoice] = useState(false)
  const [openImportModal, setOpenImportModal] = useState(false)
  const [centeredModal, setCenteredModal] = useState(false)

  const withSelectedData = [
    { value: null, label: 'With Selected' },
    { value: 'allocate_invoice', label: 'Allocate Invoice' },
    { value: 'delete_bookings', label: 'Delete Bookings' },

  ]

  const getBooking = () => {
    setPending(true)
    JobService.getJobList(entity_id, {
      per_page: 17,
      page: currentPage,
      customer: currentCustomer?.value ? currentCustomer?.value : null,
      status: currentStatus?.value ? currentStatus?.value : null,
      tag: currentTag?.value ? currentTag?.value : null,
      search: searchTerm ? searchTerm : null,
      start_date: bookingDate?.length ? (bookingDate[0] ? moment(bookingDate[0]?.toISOString()).format("YYYY-MM-DD") : null) : null,
      end_date: bookingDate?.length ? (bookingDate[1] ? moment(bookingDate[1]?.toISOString()).format("YYYY-MM-DD") : null) : null,
      sort_by: sortOrder ? sortOrder : null,
      order_by: sort ? sort : null,
      payment_status: currentPayment?.value ? currentPayment?.value : null
    })
      .then((res: any) => {
        if (currentPage > 1) {
          setBookingData(pre => [...pre, ...res?.data?.response?.data])
          if (selectAll?.checkbox) {
            const newLoadedIds = []
            res?.data?.response?.data?.map((item: any) => {
              if (!item?.payment_status?.id) newLoadedIds.push(item?.id)
            })
            setChangeCheckbox((prev) => [...prev, ...newLoadedIds])
            setSelectAll((prev) => ({ ...prev, count: (changeCheckbox?.length + newLoadedIds?.length) }))
          }
        } else setBookingData(res?.data?.response?.data)
        setNextPage(res?.data?.response?.next_page_url)
      })
      .catch((err: any) => {
        // toast.error(err?.response?.data?.message)
        console.log('err 82', err?.response?.data?.message)
      })
      .finally(() => setPending(false))
  }

  const loadOptions = (inputValue: any, callback: any) => {
    if (customerTimeoutId) {
      clearTimeout(customerTimeoutId);
    }
    customerTimeoutId = setTimeout(() => {
      const obj = {
        getall: 1,
        fields: 'id,customer_name',
        customer_name: inputValue
      }
      CustomerService.getCustomerList(entity_id, obj)
        .then((res: any) => {
          callback(res?.data?.response?.map((item: any) => {
            return { value: item?.id, label: item?.customer_name }
          }))
        })
        .catch(err => console.log(err?.response?.data?.message))
    }, 1000)
  }

  function getStatusList() {
    JobService.getJobStatusList(entity_id)
      .then((res: any) => {
        const customerList = res?.data?.response?.map((item: any) => {
          return { value: item?.id, label: item?.label }
        })
        const dafault = { value: '', label: 'Select Status' }
        setStatusData([dafault, ...customerList])
      })
      .catch((err: any) => {
        // toast.error(err?.response?.data?.message)
        console.log('err 118', err?.response?.data?.message)
      })
  }

  function getTagList() {
    const data = {
      getall: 1,
      fields: 'id,name'
    }
    TagsService.getTagsList(entity_id, data)
      .then((res: any) => {
        const tagsList = res?.data?.response?.map((item: any) => {
          return { value: item?.id, label: item?.name }
        })
        setTagData(pre => [...pre, ...tagsList])
      })
      .catch((err: any) => {
        // toast.error(err?.response?.data?.message)
        console.log('err 136', err?.response?.data?.message)
      })
  }

  function getPaymentList() {
    JobService.getPaymentList(entity_id)
      .then((res: any) => {
        const list = res?.data?.response?.map((item: any) => {
          return { value: item?.id, label: item?.label }
        })
        setPaymentData(pre => [...pre, ...list])
      })
      .catch((err: any) => {
        // toast.error(err?.response?.data?.message)
        console.log('err 150', err?.response?.data?.message)
      })
  }

  useEffect(() => {
    getStatusList()
    getTagList()
    getPaymentList()
  }, [])

  const handleSearch = (val: any) => {
    setSearchTerm(val)
    setFilterValue({ ...filterValue, bookings: { ...filterValue?.bookings, booking_search: val } })
    clearCheckbox()
  }

  useEffect(() => {
    if (searchTerm) {
      const delayDebounceFn = setTimeout(() => {
        scrollTop()
      }, 1000);
      return () => clearTimeout(delayDebounceFn)
    } else {
      scrollTop()
    }
  }, [searchTerm])

  useEffect(() => {
    if (renderElementService) {
      setRenderElementService(0)
      getBooking()
    }
  }, [renderElementService])

  function handleScroll(event: any) {
    const scrollHeight = event.target.scrollTop + event.target.clientHeight
    const elementHeight = event.target.scrollHeight
    if (event.target.scrollTop > 0) {
      if (((scrollHeight + 100) >= elementHeight) && nextPage && !pending && !renderElementService) {
        setCurrentPage((p: any) => p + 1)
        setRenderElementService((prev) => prev + 1)
      }
    }
  }

  function scrollTop() {
    const table = document.getElementById('booking_table')
    table.scrollTo(0, 0)
    setCurrentPage(1)
    setRenderElementService(1)
  }

  const handleClearDate = () => {
    scrollTop();
    setBookingDate([null, null]);
    setSelectedDateRange([null, null]);
    setFilterValue({ ...filterValue, bookings: { ...filterValue?.bookings, date: [null, null] } })
  };

  const handleDateChange = () => {
    setBookingDate(selectedDateRange)
    setFilterValue({ ...filterValue, bookings: { ...filterValue?.bookings, date: selectedDateRange } })
    clearCheckbox()
    scrollTop()
  }

  function onChangeFilter(event: any, fieldText: any) {
    setSortOrder('asc');
    const sort = tableHearderField?.map((item: any) => {
      if (item?.value == fieldText) {
        if (event) return { ...item, asc_desc: false };
        return { ...item, asc_desc: true };
      } else {
        return { ...item, asc_desc: undefined }
      }
    })
    setTableHearderField(sort);
    if (event) setSortOrder('desc');
    setSort(fieldText);
    scrollTop();
    setFilterValue({ ...filterValue, bookings: { ...filterValue?.bookings, sort_by: fieldText, order_by: event ? 'desc' : 'asc' } })
  }


  function changeper(item: any, value: any) {
    let UpdateList = [...changeCheckbox]
    if (value) {
      UpdateList = [...changeCheckbox, item?.id]
      setSelectAll((prev) => ({ ...prev, count: UpdateList?.length }))
    } else {
      UpdateList.splice(changeCheckbox.indexOf(item?.id), 1)
      setSelectAll((prev) => ({ ...prev, all: false, checkbox: false, count: UpdateList?.length }))
    }
    setChangeCheckbox(UpdateList)
  }

  function handleSelectAll(value: any) {
    if (value) {
      const ids = [];
      bookingData?.map((item: any) => {
        if (!item?.payment_status?.id) ids.push(item?.id);
      })
      setChangeCheckbox(ids)
      setSelectAll((prev) => ({ ...prev, checkbox: true, count: ids?.length }))
    } else {
      setChangeCheckbox([])
      setSelectAll((prev) => ({ ...prev, all: false, checkbox: false, count: 0 }))
    }
  }

  useEffect(() => {
    if (bookingData?.length) {
      const array = []
      bookingData?.map((item) => {
        if (changeCheckbox.includes(item?.id)) {
          array.push(item)
        }
      })
      setCheckedData(array)
    }
  }, [changeCheckbox, bookingData])

  const clearCheckbox = () => {
    setChangeCheckbox([])
    setCheckedData([])
    setSelectAll({ all: false, checkbox: false, count: 0 })
  }

  function forceDeleteBooking() {
      setPending(true)
      const params = {
        booking_ids:checkedData.map(item => item.id)
      }
      JobService.deleteMultipleJob(entity_id, params)
        .then((res: any) => {
          toast.success(res?.data?.message)
          setCenteredModal(false)
          setRenderElementService(1)
          clearCheckbox()

        })
        .catch((err: any) => {
          toast.error(err?.response?.data?.message)
        })
        .finally(() => setPending(false))
    }
  

  return (
    <>
      <InvoiceModel
        openInvoice={openInvoice}
        setOpenInvoice={setOpenInvoice}
        bookingData={checkedData}
        setRenderElementService={setRenderElementService}
        createInvoice={clearCheckbox}
      />
      <ConfirmModal
        isOpen={centeredModal}
        onHide={() => setCenteredModal(false)}
        ondelete={forceDeleteBooking}
        loader={pending}
        title={`Delete Bookings`}
        body={`Are you sure you wish to delete bookings ? The bookings and any associated jobs will be removed and cannot be restored.`}
      />
      <ImportBookingModal
        openImportModal={openImportModal}
        setOpenImportModal={setOpenImportModal}
        setRenderElementService={setRenderElementService}
        setCurrentPage={setCurrentPage}
      />
      <KTCard className='mb-3'>
        <KTCardBody className='p-5'>
          <Container fluid>
            <Row>
              <Col style={{ width: '15%' }} className='d-flex align-items-center p-0'>
                <Input type='search' placeholder='Search Bookings..' value={searchTerm} onChange={(e) => handleSearch(e?.target?.value)} />
              </Col>
              <Col style={{ width: '15%' }} className='d-flex align-items-center'>
                <AsyncSelect
                  isClearable={true}
                  className='react-select w-100'
                  classNamePrefix='select'
                  placeholder='Select Client..'
                  isRtl={false}
                  name='callback-react-select'
                  theme={selectThemeColors}
                  styles={customSelectStyles(null)}
                  loadOptions={loadOptions}
                  value={currentCustomer}
                  cacheOptions
                  onChange={(data: any) => {
                    scrollTop()
                    setCurrentCustomer(data)
                    setFilterValue({ ...filterValue, bookings: { ...filterValue?.bookings, customer: data || { value: '', label: 'Select Client' } } })
                    clearCheckbox()
                  }}
                />
              </Col>
              <Col style={{ width: '15%' }} className='d-flex align-items-center p-0'>
                <ReactSelect
                  isClearable={false}
                  isSearchable={false}
                  className='react-select w-100 text-start'
                  classNamePrefix='select'
                  theme={selectThemeColors}
                  styles={customSelectStyles(null)}
                  options={statusData}
                  value={currentStatus}
                  onChange={(data: any) => {
                    scrollTop()
                    setCurrentStatus(data)
                    setFilterValue({ ...filterValue, bookings: { ...filterValue?.bookings, status: data } })
                    clearCheckbox()
                  }}
                />
              </Col>
              <Col style={{ width: '15%' }} className='d-flex align-items-center'>
                <ReactSelect
                  isClearable={false}
                  isSearchable={false}
                  className='react-select w-100 text-start'
                  classNamePrefix='select'
                  theme={selectThemeColors}
                  styles={customSelectStyles(null)}
                  options={tagData}
                  value={currentTag}
                  onChange={(data: any) => {
                    scrollTop()
                    setCurrentTag(data)
                    setFilterValue({ ...filterValue, bookings: { ...filterValue?.bookings, tag: data } })
                    clearCheckbox()
                  }}
                />
              </Col>
              <Col style={{ width: '15%' }} className='d-flex align-items-center'>
                <ReactSelect
                  isClearable={false}
                  isSearchable={false}
                  className='react-select w-100 text-start'
                  classNamePrefix='select'
                  theme={selectThemeColors}
                  styles={customSelectStyles(null)}
                  options={paymentData}
                  value={currentPayment}
                  onChange={(data: any) => {
                    scrollTop()
                    setCurrentPayment(data)
                    setFilterValue({ ...filterValue, bookings: { ...filterValue?.bookings, payment: data } })
                    clearCheckbox()
                  }}
                />
              </Col>
              <Col style={{ minWidth: '25%' }} className='d-flex align-items-center'>
                <MultiDatePickr
                  handleClearDate={handleClearDate}
                  handleDateChange={handleDateChange}
                  date={bookingDate}
                  selectedDateRange={selectedDateRange}
                  setSelectedDateRange={setSelectedDateRange}
                />
                <div className='ms-2' style={{ minWidth: '125px' }}>
                  {/* <a href='#' className='btn btn-sm btn-primary w-100' onClick={() => navigate('/booking/add')}>
                    <KTIcon iconName='plus' className='fs-3' />
                    New Booking
                  </a> */}

                  <div>
                    <div
                      className={clsx('cursor-pointer symbol')}
                      data-kt-menu-trigger="{default: 'click'}"
                      data-kt-menu-attach='parent'
                      data-kt-menu-placement='bottom-end'
                    >
                      <div style={bookingStyle}>
                        New booking
                      </div>
                    </div>
                    <div
                      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold fs-6 w-150px'
                      data-kt-menu='true'
                    >
                      <div className='menu-item'>
                        <div className='menu-link px-5' onClick={() => setOpenImportModal(true)}>
                          Import
                        </div>
                      </div>
                      <div className='menu-item d-flex cursor-pointer' >
                        <Link to={'/booking/add'} className='menu-link px-5'>
                          New booking
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </KTCardBody>
      </KTCard>
      <KTCard>
        <KTCardBody className='p-0'>
          <Row className='px-10 py-5'>
            <Col md="2" className='d-flex align-items-center p-0'>
              <ReactSelect
                isClearable={false}
                isSearchable={false}
                className='react-select w-100 text-start'
                classNamePrefix='select'
                theme={selectThemeColors}
                styles={customSelectStyles(null)}
                isDisabled={changeCheckbox?.length === 0}
                options={withSelectedData}
                value={currentSelected}
                onChange={(data: any) => {
                  setCurrentSelected(data)
                  if (data?.value === 'allocate_invoice') {
                    const data = selectAll?.all ? bookingData : bookingData?.filter((item: any) => {
                      if (changeCheckbox.includes(item?.id)) { return item }
                    })
                    const isSame = data?.every((item: any) => item.customer_id === data[0].customer_id);

                    if (isSame) setOpenInvoice(true)
                    else toast.error('Sorry, you can only do this for Bookings with the same Client.')

                  } else if(data?.value === 'delete_bookings') {
                    setCenteredModal(true)
                  }
                }}
              />
            </Col>
            <Col md="10" className=''>
            </Col>
          </Row>
          <UILoader blocking={pending} loader={<ComponentSpinner />} overlayColor='rgba(245, 245, 240, .1)' className={pending ? 'loader-blur' : ''}>
            <div onScroll={(e) => handleScroll(e)} id='booking_table' className='jobs-table-style'>
              <Table className='jobs-table'>
                <thead className='sticky-header'>
                  <tr style={{ fontWeight: '500' }}>
                    <th className='ps-3'>
                      <Input type='checkbox' checked={changeCheckbox?.length ? (changeCheckbox?.length === (bookingData?.filter(item => !item?.payment_status?.id)?.length)) : false}
                        onChange={(e) => {
                          handleSelectAll(e.target.checked)
                        }}
                      />
                    </th>
                    {selectAll.checkbox ?
                      <th colSpan={tableHearderField?.length}>
                        <div>
                          {selectAll?.all ? 'All in the result selected.' : `${selectAll?.count} Selected.`}
                          <span style={{ color: 'blue', cursor: 'pointer', paddingLeft: '5px', fontWeight: '500' }} onClick={() => setSelectAll((prev) => ({ ...prev, all: !prev?.all }))}>
                            {selectAll?.all ? 'Undo' : 'Select all in this result set.'}
                          </span>
                        </div>
                      </th> :
                      tableHearderField?.map((item: any, index: any) => {
                        return (
                          <th className='ps-3' key={index}>
                            <div onClick={() => { item?.value ? onChangeFilter(item?.asc_desc, item?.value) : '' }} style={{ cursor: item?.style }}>
                              {item.label}
                              {item?.value && item.asc_desc !== undefined &&
                                <span>
                                  {item.asc_desc ? <Icon icon="raphael:arrowdown" /> : <Icon icon="raphael:arrowup" />}
                                </span>
                              }
                            </div>
                          </th>
                        )
                      })
                    }
                  </tr>
                </thead>
                <tbody>
                  {bookingData?.map((item: any, i: any) => {
                    return (
                      <tr key={i} style={{ borderBottom: '1px solid rgba(0, 0, 0, .12)' }}>
                        <td className='ps-3' style={{ width: '40px' }}>
                          <Input type='checkbox' value={item?.id}
                            disabled={item?.payment_status?.id}
                            checked={changeCheckbox.includes(item?.id)}
                            onChange={(e) => changeper(item, e.target.checked)}
                          />
                        </td>
                        <td className='ps-3' style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          <div onClick={() => navigate(`/booking/${item?.id}/edit`)} className='fw-bold cursor-pointer fs-6 theme-color' >
                            {item?.booking_number}
                          </div>
                          <span>{item?.job_status?.label}</span>
                        </td>
                        <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          <div>{item?.job_name}</div>
                        </td>
                        <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          <div>{item?.customer_name}</div>
                        </td>
                        <td style={{ maxWidth: '150px' }}>
                          <div>
                            {item?.drop_off_locations}
                          </div>
                          {/* <div className='d-flex'>
                            {item?.tags?.map((item: any, index: any) => {
                              return (
                                <span key={index} className='px-2 me-2' style={{color: 'white', backgroundColor: item?.color}}>{item?.name}</span>
                              )
                            })}
                          </div> */}
                        </td>
                        <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          <div>
                            {/* { item?.coachiejoblegs?.length ?
                                (item?.coachiejoblegs?.length > 1 ? 
                                ((item?.coachiejoblegs[0]?.start_at_date ? moment(item?.coachiejoblegs[0]?.start_at_date).format('DD-MM-YYYY') : '') + ' - ' + (item?.coachiejoblegs[item?.coachiejoblegs?.length - 1]?.start_at ? moment(item?.coachiejoblegs[item?.coachiejoblegs?.length - 1]?.start_at_date).format('DD-MM-YYYY') : '')) : 
                                (item?.coachiejoblegs[0]?.start_at_date ? moment(item?.coachiejoblegs[0]?.start_at_date).format('DD-MM-YYYY') : '')) 
                              : ''
                            } */}
                            {item?.jobs_start_array?.map((data: any, index: any) => {
                              return `${data ? moment(data, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''}${index < item?.jobs_start_array?.length - 1 ? " - " : ""}`
                            })}
                          </div>
                        </td>
                        <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          <div>{item?.payment_status?.label} </div>
                        </td>
                        <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          <div>{item?.job_count} </div>
                        </td>
                        <td style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          <div>{item?.price_by_job_legs ? formatCurrency(item?.job_leg_sum || 0) : formatCurrency(item?.job_price || 0)}</div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
              {bookingData?.length === 0 ?
                <p className='d-flex justify-content-center'>There are no Bookings to display</p>
                : ''
              }
            </div>
          </UILoader>
        </KTCardBody>
      </KTCard>
    </>
  )
}

export { JobPage }
